module.exports = "/_next/static/images/tv-d14123479f994d99613c8e1caafcbbbb.svg";